import React, { useEffect } from 'react';
import {
    AppBar,
    Box,
    Tabs,
    Tab,
    Typography,
} from '@material-ui/core';
import './ScrollableTabsButtonAuto.scss';

/**
 * @param {{
 *  children: React.ReactNode,
 *  index: any,
 *  value: any
 * }} props
 * @returns React.StatelessComponent
 */
function TabPanel(props) {
    const {
        children,
        value,
        index,
        ...other
    } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}
/**
 * @param {{
 *  className: string;
 *  tabs: {
 *      label: string,
 *      content: JSX.Element
 *  }[]
 * }} props
 * @returns
 */
export default function ScrollableTabsButtonAuto(props) {
    const { tabs, className = '' } = props;

    const [tabSelected, setTabSelected] = React.useState(0);
    const handleChange = (event, newTabSelected) => {
        setTabSelected(newTabSelected);
    };
    const tabLabels = [];
    const tabPanels = [];
    tabs.forEach((tab, index) => {
        tabLabels.push(
            <Tab
                key={`stba-tab-${tab.label + index}`}
                label={tab.label}
                {...a11yProps(index)}
            />,
        );
        tabPanels.push(
            <TabPanel
                key={`stba-tabPanel-${tab.label + index}`}
                value={tabSelected}
                index={index}
            >
                {tab.content}
            </TabPanel>,
        );
    });
    useEffect(() => {
        if (tabs.length) {
            setTabSelected(0);
        }
    }, [tabs.length]);
    return (
        <div className={`${className} scrollable-tabs-button-auto-root`}>
            <AppBar
                position="static"
                color="default"
            >
                <Tabs
                    value={tabSelected}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >
                    {tabLabels}
                </Tabs>
            </AppBar>
            {tabPanels}
        </div>
    );
}
